import React from 'react';
import './ModelStatusBanner.css';

/**
 * Lives at the top of Dashboard / Graphs / Insights. Renders one of
 * three states based on the latest init handshake:
 *
 *   NOTHING  → renders nothing (null). Cached output is fresh.
 *   STARTED  → "Computing your latest results…" with a spinner
 *   RUNNING  → same as STARTED, different copy: "Still working…"
 *   FAILED   → red strip with a Retry button that calls onRetry

 */
export default function ModelStatusBanner({ status, phase, onRetry }) {
  // First load — don't flash a banner before init returns.
  if (phase === 'idle' || phase === 'loading') return null;

  // Backend explicitly told us nothing's running. So no banner
  if (status === 'NOTHING' || status == null) return null;

  if (status === 'FAILED') {
    return (
      <div className="model-status-banner is-error">
        <svg className="model-status-banner__icon" width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
          <path d="M12 7v6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
          <circle cx="12" cy="16.5" r="1" fill="currentColor" />
        </svg>
        <span className="model-status-banner__text">
          Couldn't start the analysis. Refresh or try again.
        </span>
        {onRetry && (
          <button type="button" className="model-status-banner__retry" onClick={onRetry}>
            Retry
          </button>
        )}
      </div>
    );
  }

  // STARTED and RUNNING share the same shape, different copy.
  const copy =
    status === 'STARTED'
      ? 'Computing your latest results…'
      : 'Still working — results coming in a moment.';

  return (
    <div className="model-status-banner">
      <span className="model-status-banner__spinner" aria-hidden="true" />
      <span className="model-status-banner__text">{copy}</span>
    </div>
  );
}
